import { tasksId } from "../../../types/activityTasks";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import React, { useEffect, useState } from "react";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { audiosAssets } from "../../../assets/audio";
import { PanelInstrucionHands } from "../../../components/common/PanelInstrucionHands";
import { imgsTopic4 } from "../../../assets/imgs/Tema4";
import { ModalInfo } from "../../../components/common/ModalInfo";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogOne: 1,
	viewActivities: 2,
	dialogTwo: 3,
	activityInfo: 4,
	modalOne: 5,
	modalTwo: 6,
	modalThree: 7,
	modalFour: 8,
	modalFive: 9,
	modalSix: 10,
	modalSeven: 11,
	dialogThree: 12,
	win: 13,
	touchActivity: 20,
}

export const Tema5SubtopicTwoActivityOne = () => {
	const dispatch = useDispatch();
	const navigation = useNavigate();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(1);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema5.activities.subtema2], 1);
	useEffect(() => {
		if (loaded) {
			console.log("tema 5 subtema2 activity 1");
			ObserverEmitter.emit(EVENTS.tema5.subtopicTwo.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.selectCharacterScene)
		}
	}, [loaded]);
	ObserverEmitter.on(EVENTS.tema5.subtopicTwo.activityOne.nextUI, (nextUI) => {
		const modalSteps = {
			1: steps.modalOne,
			2: steps.modalTwo,
			3: steps.modalThree,
			4: steps.modalFour,
			5: steps.modalFive,
			6: steps.modalSix,
			7: steps.modalSeven,
		}
		setUiToShow(modalSteps[nextUI]);
	})
	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub02.sub2_act1_a01)
	})
	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{[2, 3, 4, 12, 13].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema5.subtopicTwo.initScene, 1);
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialogOne && (
				<>
					<HeaderRedPresentation name="Actividad 1: Retiro de efectivo." />
					<DialogBarNew
						dialog={
							'Vayamos a nuestro siguiente tema, "Retiro de efectivo”.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.idle);
							setUiToShow(steps.viewActivities);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.viewActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2: Retiro de efectivo"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							setUiToShow(steps.dialogTwo);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub02.sub2_act1_a02)
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.dialogTwo && (
				<>
					<DialogBarNew
						dialog={
							"El Retiro de Efectivo lleva una serie de pasos, similares a las corresponsalías. ¡Te explico!"
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.characterAnimations.idle);
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.activityInfo);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.activityInfo && (
				<>
					<PanelInstrucionHands
						text="Explora tocando los objetos iluminadas."
						action={() => {
							setUiToShow(steps.touchActivity);
							ObserverEmitter.emit(EVENTS.tema5.subtopicTwo.activityOne.showOrHideModels, true)
							ObserverEmitter.emit(EVENTS.tema5.subtopicTwo.activityOne.touchObject, 1)
							ObserverEmitter.emit(EVENTS.tema5.subtopicTwo.activityOne.amplifyDesk)
						}}
						img={imgsTopic4.infoSub2Act2}
					/>
				</>
			)}
			{uiToShow === steps.modalOne && (
				<>
					<ModalInfo
						title="Primer Paso:"
						description='Da clic encima de la opción "Financieros" en la pantalla, o presiona la tecla "S".'
						action={() => {
							ObserverEmitter.emit(EVENTS.tema5.subtopicTwo.activityOne.touchObject, 2)
							setUiToShow(steps.touchActivity);
						}}
					></ModalInfo>
				</>
			)}
			{uiToShow === steps.modalTwo && (
				<>
					<ModalInfo
						title="Segundo Paso:"
						description="Pregunta al Cliente si llevará productos."
						action={() => {
							ObserverEmitter.emit(EVENTS.tema5.subtopicTwo.activityOne.touchObject, 3)
							setUiToShow(steps.touchActivity);
						}}
					></ModalInfo>
				</>
			)}
			{uiToShow === steps.modalThree && (
				<>
					<ModalInfo
						title="Tercer Paso:"
						description="Si el cliente lleva productos: escanea los productos y presiona la tecla T. Si el cliente NO lleva productos: pasa al paso 4 directamente."
						action={() => {
							ObserverEmitter.emit(EVENTS.tema5.subtopicTwo.activityOne.touchObject, 4)
							setUiToShow(steps.touchActivity);
						}}
					></ModalInfo>
				</>
			)}
			{uiToShow === steps.modalFour && (
				<>
					<ModalInfo
						title="Cuarto Paso:"
						description="Pasa la tarjeta por el PIN PAD y solicita al cliente digitar el CVV de su tarjeta."
						action={() => {
							ObserverEmitter.emit(EVENTS.tema5.subtopicTwo.activityOne.touchObject, 5)
							setUiToShow(steps.touchActivity);
						}}
					></ModalInfo>
				</>
			)}
			{uiToShow === steps.modalFive && (
				<>
					<ModalInfo
						title="Quinto Paso:"
						description="Confirma la cantidad de dinero y captura la cantidad a retirar con el Cliente."
						action={() => {
							ObserverEmitter.emit(EVENTS.tema5.subtopicTwo.activityOne.touchObject, 6)
							setUiToShow(steps.touchActivity);
						}}
					></ModalInfo>
				</>
			)}
			{uiToShow === steps.modalSix && (
				<>
					<ModalInfo
						title="Sexto Paso:"
						description="Selecciona tu usuario dentro del cajero e ingresa tu contraseña."
						action={() => {
							ObserverEmitter.emit(EVENTS.tema5.subtopicTwo.activityOne.touchObject, 7)
							setUiToShow(steps.touchActivity);
						}}
					></ModalInfo>
				</>
			)}
			{uiToShow === steps.modalSeven && (
				<>
					<ModalInfo
						title="Septimo Paso:"
						description="Verifica que haya suficiente dinero en caja."
						action={() => {
							ObserverEmitter.emit(EVENTS.tema5.subtopicTwo.activityOne.showOrHideModels, false)
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk)
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub02.sub2_act1_a03)
							setUiToShow(steps.dialogThree);
						}}
					></ModalInfo>
				</>
			)}
			{uiToShow === steps.dialogThree && (
				<>
					<DialogBarNew
						dialog={
							'¡Recuerda! El monto máximo que puede ser retirado es de $2,000 pesos.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.win);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.touchActivity && (
				<>
					<BarStatusActivies activities={tasksList} />
				</>
			)}
			{uiToShow === steps.win && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={10}
						dialogModal="¡Excelente! Ahora ya sabes los pasos para el retiro de efectivo."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 1,
									pointsWin: 10,
									subtema: tasksId.tema5.activities.subtema2,
								})
							);
							navigation("/home5/tema5/subtema2/activityTwo");
						}}
					/>
				</>
			)}

		</>

	)
}